// removed by extract-text-webpack-plugin
module.exports = {"box":"_18B51-7bQw5mEAOvu7gDWk"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/GymFinished/style.module.css
// module id = 516
// module chunks = 37